(function ($) {
  'use strict';

  var $window = $(window);
  var $headerSticky = $('.header-navigation');

  $window.on('scroll', function () {
    if ($window.scrollTop() >= 100 && $window.width() > 767) {
      $headerSticky.addClass('sticky');
    } else {
      $headerSticky.removeClass('sticky');
    }
  });

  $window.trigger('scroll');

  $('a[href*="#"]').on('click', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');

    if (href === '#') {
      return;
    }

    $('html, body').animate({scrollTop: $(href).offset().top}, 500)
  });

  var $offCanvasNav = $('.offcanvas-navigation');
  var $offCanvasNavSubMenu = $offCanvasNav.find('.sub-menu');

  $offCanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');
  $offCanvasNavSubMenu.slideUp();

  $offCanvasNav.on('click', 'li a, li .menu-expand', function(e) {
    var $this = $(this);

    if ( ($this.parent().attr('class').match(/\b(menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand')) ) {
      e.preventDefault();
      if ($this.siblings('ul:visible').length){
        $this.parent('li').removeClass('active');
        $this.siblings('ul').slideUp();
      } else {
        $this.parent('li').addClass('active');
        $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
        $this.closest('li').siblings('li').find('ul:visible').slideUp();
        $this.siblings('ul').slideDown();
      }
    }
  });

  $('#mobile-menu-trigger').on('click', function(){
    $('#offcanvas-mobile-menu').removeClass('inactive').addClass('active');
  });


  $('#offcanvas-menu-close-trigger').on('click', function(){
    $('#offcanvas-mobile-menu').removeClass('active').addClass('inactive');
  });
})(jQuery);

(function(w,d,u){
  var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
  var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
})(window,document,'https://cdn.bitrix24.com/b12254607/crm/site_button/loader_1_fd96p9.js');
